export const useContactPermissions = (user) => {
  if (!user) return { isAdmin: false, isTelecaller: false };

  const role = user.role?.toLowerCase() || '';

  const isAdmin = ['admin', 'owner', 'systemadmin', 'SD-admin'].includes(role);
  const isTelecaller = ['telecaller', 'telecalling', 'telesale', 'marketing'].includes(role);

  return {
    isAdmin,
    isTelecaller,
    role
  };
};




